<h1>{{ "register.title" | translate }}</h1>
<p class="oidc-registration-description">{{ "register.description" | translate }}</p>
<obg-m-id-select-component></obg-m-id-select-component>
